import { render, staticRenderFns } from "./new_user_page.vue?vue&type=template&id=a46877a8"
import script from "./new_user_page.vue?vue&type=script&lang=js"
export * from "./new_user_page.vue?vue&type=script&lang=js"
import style0 from "./new_user_page.vue?vue&type=style&index=0&id=a46877a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports